import { FilterParams, Genre, Movie, Provider, RecommendedTvShow } from '../models/data';
import { baseUrlPlatform } from '../resources/constants';
import axios from 'axios';
import QueryString from 'qs';

export const getLatestTvShow = (): Promise<number> => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${baseUrlPlatform}tv_shows/latest`)
            .then((response: any) => resolve(response.data.id))
            .catch((error) => reject(error));
    });
};

export const getTvShowsGenres = (): Promise<Genre[]> => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${baseUrlPlatform}tv_shows/genres`)
            .then((response: any) => resolve(response.data.results ?? []))
            .catch((error) => reject(error));
    });
};

export const getTvShowsProviders = (): Promise<Provider[]> => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${baseUrlPlatform}tv_shows/providers`)
            .then((response: any) => resolve(response.data.results ?? []))
            .catch((error) => reject(error));
    });
};

export const getTvShowRandom = (): Promise<Movie> => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${baseUrlPlatform}tv_shows/random`)
            .then((response: any) => resolve(response.data.result))
            .catch((error) => reject(error));
    });
};

export const getTvShowDetail = (id: number): Promise<Movie> => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${baseUrlPlatform}tv_shows/detail/${id}`)
            .then((response: any) => resolve(response.data.result))
            .catch((error) => reject(error));
    });
};

export const getTvShowFiltered = (filter: FilterParams): Promise<Movie> => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${baseUrlPlatform}tv_shows/filtered`, {
                params: { ...filter },
                paramsSerializer: (params) => QueryString.stringify(params, { encode: false }),
            })
            .then((response: any) => resolve(response.data.result))
            .catch((error) => reject(error));
    });
};

export const getRecommendedTvShow = (uid: number): Promise<RecommendedTvShow> => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${baseUrlPlatform}tv_shows/recommended`, {
                params: { uid },
                paramsSerializer: (params) => QueryString.stringify(params, { encode: false }),
            })
            .then((response: any) => resolve(response.data))
            .catch((error) => reject(error));
    });
};
